namespace GeniuzPOS.Administration {
    export class PsFuncKbMapKeyCodeColumns {
        static columnsKey = 'Administration.PsFuncKbMapKeyCode';
    }
}
